import { createListFromObject } from "../../Utilities/Types/listUtilities";

export const REPORT_TYPES = {
    UserManagement: "patrons",
    OwnOrdersPending: "orders",
    LoanHistory: "loan-library",
    OwnOrdersCompleted: "orders-completed"
};

export const REPORT_TYPE_DESCRIPTIONS: Record<string, string> = {
    [REPORT_TYPES.UserManagement]: "Exports a list of all patrons including their roles, approval status, organization, and district.",
    [REPORT_TYPES.OwnOrdersPending]: "Exports a list of active own library orders currently awaiting processing.",
    [REPORT_TYPES.LoanHistory]: "Exports a historical record of loan library checkouts including due dates and return status.",
    [REPORT_TYPES.OwnOrdersCompleted]: "Exports a history of fulfilled own library orders, filterable by date created and date fulfilled.",
};

export const REPORT_TYPES_LIST = createListFromObject(REPORT_TYPES);